import InnerBox from '@repo/ui/inner-box'
import MultiSelectInput from '@repo/ui/multiselect-input'
import { useQuery } from '@tanstack/react-query'
import { useFormContext } from 'react-hook-form'

import { getCountries } from '../../../api/countries/get-countries'
import { StaffApplicationInput } from '../../../lib/types/models/staff-application/staff-application-input'
import { FormControl, FormField, FormItem } from '../../elements/forms/form'

const StaffApplicationFormCountriesWishList = () => {
  const form = useFormContext<StaffApplicationInput>()

  const { data: countries } = useQuery({
    queryKey: ['countries'],
    queryFn: () => getCountries()
  })

  return (
    <InnerBox title="Pays souhaités">
      <FormField
        control={form.control}
        name="countriesWishList"
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <MultiSelectInput
                {...field}
                label="Liste de pays souhaités"
                variant="primary"
                options={
                  countries?.data.map((country) => ({
                    label: country.name,
                    value: country.id
                  })) ?? []
                }
                selectedOptions={
                  field.value?.map((countryId) => ({
                    label: countries?.data.find((country) => country.id === countryId)?.name ?? '',
                    value: countryId
                  })) ?? []
                }
              />
            </FormControl>
          </FormItem>
        )}
      />
    </InnerBox>
  )
}

export default StaffApplicationFormCountriesWishList
